import $ from 'jquery';
import isInViewport from '../util/isInViewport';
import throttle from '../util/throttle';

const $navItems = $('.js-product-nav-link');
const $targets = $navItems.map(function() {
	return $(this.hash);
});

const ProductNav = {
	addScrollEvents() {
		$(window).on('scroll', throttle(() => {
			const $currentTarget = $targets.toArray().find(t => isInViewport(t, 90));
			$navItems.removeClass('is-active');
			if ($currentTarget) {
				const $currentNavItem = $navItems.filter(function(i, el) {
					return el.hash == `#${$currentTarget[0].id}`
				});
				$currentNavItem.addClass('is-active');
			}
		}, 500));
	},

	init() {
		if ($navItems.length) {
			this.addScrollEvents();
		}
	}
};

export default ProductNav;